import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import './index.css';
import HarmoneePulse from './HarmoneePulse';

// ──── PostHog Analytics — privacy-preserving config ────
// Session recording is OFF: it would replay the actual screen (your morning brief,
// inbox, ARIA chat, docs) to PostHog's cloud. We keep behavioral analytics instead —
// pageviews, clicks/funnels, heatmaps, and our hand-defined events (which carry only
// metadata: intent, model, counts — never email or document content).
posthog.init('phc_qy6JBjGZxjsnStJDbNzmk4cQSMet7rAKhmYBhFibmxYx', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  disable_session_recording: true, // no screen replay — your data stays in the browser
  enable_heatmaps: true,
  // Belt-and-suspenders: never capture the text content of clicked elements
  // (so an email subject rendered as a link can't leak via autocapture)
  mask_all_text: true,
  sanitize_properties: (props) => {
    // Strip any element text/value PostHog tries to attach to autocaptured events
    for (const k of ['$el_text', '$elements_chain']) {
      if (props[k]) delete props[k];
    }
    return props;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <HarmoneePulse />
    </PostHogProvider>
  </React.StrictMode>
);
